import React from "react";
import { Box, Typography, Button, Dialog } from "@mui/material";
import { CheckCircle, AlertCircle } from "lucide-react";

export type RsvpNoteDialogType = "confirm" | "invalid" | null;

interface RsvpNoteDialogProps {
  open: boolean;
  onClose: () => void;
  type: RsvpNoteDialogType;
}

const RsvpNoteDialog: React.FC<RsvpNoteDialogProps> = ({
  open,
  onClose,
  type,
}) => {
  if (!type) return null;

  const isConfirm = type === "confirm";
  const title = isConfirm ? "RSVP Recorded" : "RSVP Error";
  const message = isConfirm
    ? "Your event RSVP has been recorded."
    : "Error RSVPing to event. Please review the invitation or contact the inviter.";
  const Icon = isConfirm ? CheckCircle : AlertCircle;
  const iconColor = isConfirm ? "#468E3E" : "#D32F2F"; // Success green or Error red

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          padding: "24px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          textAlign: "center",
        }}
      >
        <Icon size={48} color={iconColor} />
        <Box>
          <Typography variant="h3" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body" color="text.secondary">
            {message}
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={onClose}
          fullWidth
          sx={{ marginTop: "8px" }}
        >
          Okay
        </Button>
      </Box>
    </Dialog>
  );
};

export default RsvpNoteDialog;
